module.exports = __webpack_public_path__ + "static/media/pricetag.c1f2e5ab.svg";